import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';
import Layout from '../Components/Layout/Layout';
import { Input } from "@/Components/ui/input";
import { Button } from "@/Components/ui/button";
import StyledSwitch from "../Components/Layout/StyledSwitch";
import DietaryNeedsModal from "../Components/Dishes/DietaryNeedsModal";
import ProductModal from "../Components/Products/ProductModal";
import { ChevronLeft, Plus, ChevronDown, CheckCircle2, Trash2 } from "lucide-react";
import ConfirmationModal from '../Components/Includes/ConfirmationModal';
import axiosInstance from '../utils/axiosConfig';
import { foodbookInstance } from '../utils/axiosConfig'; 

import icon1 from '../images/allergens/1.webp';
import icon3 from '../images/allergens/3.webp';
import icon4 from '../images/allergens/4.webp';
import icon5 from '../images/allergens/5.webp';
import icon11 from '../images/allergens/11.webp';
import icon12 from '../images/allergens/12.webp';
import icon16 from '../images/allergens/16.webp';
import icon17 from '../images/allergens/17.webp';
import icon19 from '../images/allergens/19.webp';
import icon21 from '../images/allergens/21.webp';
import icon22 from '../images/allergens/22.webp';
import icon23 from '../images/allergens/23.webp';
import icon24 from '../images/allergens/24.webp';
import icon26 from '../images/allergens/26.webp';
import empty from '../images/allergens/empty.png';

import icon1b from '../images/dieets/1.png';
import icon2b from '../images/dieets/2.png';
import icon3b from '../images/dieets/3.png';
import icon4b from '../images/dieets/4.png';
import icon5b from '../images/dieets/5.png';
import icon6b from '../images/dieets/6.png';
import icon7b from '../images/dieets/7.png';
import icon8b from '../images/dieets/8.png';
import icon9b from '../images/dieets/9.png';
import icon10b from '../images/dieets/10.png'; 

const Dish = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { dishId, categoryid, returnPage, activeTab } = location.state || {};
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isProductModalOpen, setIsProductModalOpen] = useState(false);
    const [nameError, setNameError] = useState('');
    const [priceError, setPriceError] = useState('');
    const [showSuccess, setShowSuccess] = useState(false);
    const [success, setSuccess] = useState('');
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [dish, setDish] = useState({
        id: null,
        name: '',
        description: '',
        price: 0,
        categoryid: -1,
        ispublished: true,
        allergens: [],
        dietaryneeds: []
    });
    const [isSaving, setIsSaving] = useState(false);
    const [categories, setCategories] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const allergenIcons = {
        1: icon1,
        3: icon3,
        4: icon4,
        5: icon5,
        11: icon11,
        12: icon12,
        16: icon16,
        17: icon17,
        19: icon19,
        21: icon21,
        22: icon22,
        23: icon23,
        24: icon24,
        26: icon26,
    };
    const dietaryIcons = {
        1: icon1b,
        2: icon2b,
        3: icon3b,
        4: icon4b,
        5: icon5b, 
        6: icon6b, 
        7: icon7b, 
        8: icon8b, 
        9: icon9b, 
        10: icon10b
    };

    const handleReturn = () => {
        if (returnPage === 'category') {
            navigate(`/${returnPage}`, { state: { categoryid } });
        } else {
            navigate(`/${returnPage}`, { state: { activeTab } });
        }
    };

    const handleReOpen = (newId) => {
        navigate('/dish', {
            state: {
                dishId: newId,
                returnPage,
                activeTab
            }
        });
    };

    const handleSaveDietaryNeeds = async (selectedNeeds) => {
        try { 
            setDish(prev => ({ ...prev, dietaryneeds: selectedNeeds }));
        } catch (error) {
            console.error('Error saving dietary needs:', error);
        }
    };

    const validateForm = () => {
        let isValid = true;
        setNameError('');
        setPriceError('');

        if (!dish.name.trim()) {
            setNameError('Naam is verplicht');
            isValid = false;
        }

        const price = parseFloat(dish.price.replace(',', '.'));
        if (isNaN(price) || price <= 0) {
            setPriceError('Voer een geldige prijs in');
            isValid = false;
        }

        return isValid;
    };

    const handleChange = useCallback((e) => {
        const { name, value } = e.target;
        setDish(prevState => ({
            ...prevState,
            [name]: value
        })); 

        if (name === 'name') setNameError('');
        if (name === 'price') setPriceError('');
    }, []);
     
    const handleSwitchChange = (checked) => {
        setDish(prevState => ({
            ...prevState,
            ispublished: checked
        }));
    };

    const handleCategoryChange = (categoryid) => { 
        setDish(prevState => ({
            ...prevState,
            categoryid: categoryid
        }));
        setIsDropdownOpen(false);
    };

    const handleSaveProduct = async (product, type) => { 
        setIsLoading(true);
        if (type === 'Ps') {
            var productSheet = await foodbookInstance.get(`/MenuApp/GetProductSheet/${product.refid}`);
            const allergenInfo = productSheet?.data?.product?.specificationinfolist?.specificationinfo?.allergenset?.allergens?.allergeninfo ?? [];
            const farmtofarm = productSheet?.data?.product?.farmtofarm ?? 0;

            var allergenList = [];
            {
                allergenInfo?.map((allergen) => {
                    if (parseInt(allergen.levelofcontainmentid) === 1) { 
                        allergenList.push({
                            id: parseInt(allergen.id),
                            name: allergen.name.value
                        });


                        var allergenExists = dish.allergens?.some(existing => existing.id === parseInt(allergen.id));
                        if (!allergenExists) {
                            dish.allergens.push({
                                id: parseInt(allergen.id),
                                name: allergen.name.value
                            });
                        }
                    }
                    return null;
                })
            }

            product.allergens = allergenList;
            product.farmtofarm = farmtofarm;
        }

        var response = await axiosInstance.post(`/dish/Add${type}Product/${dishId}`, product);
        product.id = response.data;
        

        setDish(prev => ({
            ...prev,
            products: [...prev.products, product]
        }));

        setIsLoading(false);
    };
     
    const handleAddProduct = () => {
        setIsProductModalOpen(true);
    };

    const handleSave = async () => {
        if (!validateForm()) {
            return;
        }

        try {
            setIsSaving(true);
            setError(null);
             
            const response = await axiosInstance.post('/dish/SetDish', {
                id: dish.id || 0,
                name: dish.name,
                description: dish.description,
                price: parseFloat(dish.price.replace(',', '.')), 
                categoryid: dish.categoryid,
                ispublished: dish.ispublished,
                dietaryneeds: dish.dietaryneeds
            });
            const data = await response.data; 

            if (response.status !== 200) {
                throw new Error('Failed to save dish');
            } else {
                setShowSuccess(true);
                setSuccess('Gerecht succesvol opgeslagen');

                setTimeout(() => {
                    // Volledige pagina refresh na succesvol opslaan
                    window.location.reload();
                }, 2000);
            }
        } catch (error) {
            console.error('Error saving dish:', error);
            setError(error.message);
        } finally {
            setIsSaving(false);
            window.scrollTo({ top: 0, behavior: 'smooth' }); 
        }
    };

    useEffect(() => {
        const fetchDish = async () => {
            try {
                setIsLoading(true);
                const response = await axiosInstance.get(`/dish/GetDish/${dishId}`);
                const dishData = response.data;

                // Format price when receiving from API
                if (dishData.price !== undefined && dishData.price !== null) {
                    dishData.price = dishData.price.toFixed(2).replace('.', ',');
                }

                setDish(dishData);
            } catch (error) {
                console.error('Error fetching dish:', error);
                setError(error.message);
            } finally {
                setIsLoading(false);
            }
        };

        const fetchCategories = async () => {
            try {
                const response = await axiosInstance.get('/category/GetCategories');
                setCategories(Array.isArray(response.data) ? response.data : []);
            } catch (error) {
                console.error('Error fetching categories:', error);
            }
        };

        fetchCategories();
        if (dishId && dishId !== 0) {
            fetchDish();
        } else {
            setIsLoading(false);
        }
    }, [dishId]);


    const handleRemoveProduct = async (productId) => {
        await axiosInstance.delete(`/dish/RemoveProduct/${dishId}/${productId}`); 
         
        const response = await axiosInstance.get(`/dish/GetDish/${dishId}`);
        const dishData = response.data;

        setDish(prevDish => ({
            ...prevDish,
            products: prevDish.products.filter(product => product.id !== productId),
            allergens: dishData.allergens
        }));
    }; 

    const handlePriceChange = (e) => {
        const value = e.target.value; 
        if (value === '' || /^[0-9]*.,?[0-9]{0,2}$/.test(value)) {
            setDish(prevState => ({
                ...prevState,
                price: value
            }));
            setPriceError('');
        }
    };

    const handlePriceBlur = () => {
        if (dish.price === '') return;
         
        const numericValue = parseFloat(dish.price.replace(',', '.'));

        if (!isNaN(numericValue)) {
            setDish(prevState => ({
                ...prevState,
                price: numericValue.toFixed(2).replace('.', ',')
            }));
        } else { 
            setDish(prevState => ({
                ...prevState,
                price: '0,00'
            }));
        }
    };
     
    const handleDeleteDish = async () => {
        try {
            await axiosInstance.delete(`/dish/DeleteDish/${dishId}`);
            navigate('/dishes');
        } catch (error) {
            console.error('Error deleting dish:', error);
            setError(error.message);
        }
    };

    
     

    if (isLoading) return <Layout><div>Loading...</div></Layout>;
    if (error) return <Layout><div>Error: {error}</div></Layout>;
    if (!dish) return <Layout><div>Product niet gevonden</div></Layout>;


    return (
        <Layout>
            <div className="relative max-w-[1100px] mx-auto">
                <div className="mb-8">
                    <button
                        onClick={handleReturn}
                        className="text-ps-blue-dark hover:underline font-inter"
                    >
                        <ChevronLeft className="float-left" />
                        Terug naar overzicht
                    </button>
                </div>


                {showSuccess && (
                    <div className="mb-4 p-4 bg-green-50 text-green-700 rounded-lg flex items-center gap-2">
                        <CheckCircle2 className="h-5 w-5" />
                        <span className="font-inter">{success}</span>
                    </div>
                )}

                {error && (
                    <div className="mb-4 p-4 bg-red-50 text-red-700 rounded-lg">
                        <span className="font-inter">{error}</span>
                    </div>
                )}

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div className="md:col-span-2 space-y-6">
                        <div>
                            <label className="block text-sm font-inter text-ps-blue-dark mb-2">
                                Naam
                            </label>
                            <Input
                                type="text"
                                name="name"
                                value={dish.name}
                                onChange={handleChange}
                                className={`w-full p-2 border rounded bg-white ${nameError ? 'border-red-500' : ''}`}
                            />
                            {nameError && (
                                <p className="text-red-500 text-sm mt-1 font-inter">
                                    {nameError}
                                </p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-inter text-ps-blue-dark mb-2">
                                Omschrijving
                            </label>
                            <textarea
                                name="description"
                                value={dish.description}
                                onChange={handleChange}
                                className="w-full p-2 border rounded h-32 resize-none font-inter bg-white"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-inter text-ps-blue-dark mb-2">
                                Prijs
                            </label>
                            <div className="relative">
                                <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">
                                    €
                                </span>
                                <Input
                                    type="text"
                                    name="price"
                                    value={dish.price}
                                    onChange={handlePriceChange}
                                    onBlur={handlePriceBlur}
                                    className={`w-full p-2 pl-6 border rounded bg-white ${priceError ? 'border-red-500' : ''}`}
                                    placeholder="0,00"
                                />
                            </div>
                            {priceError && (
                                <p className="text-red-500 text-sm mt-1 font-inter">
                                    {priceError}
                                </p>
                            )}
                        </div>

                        <div className="relative">
                            <label className="block text-sm font-inter text-ps-blue-dark mb-2">
                                Categorie
                            </label>
                            <div className="relative">
                                <button
                                    type="button"
                                    className="w-full flex items-center justify-between p-2 border rounded bg-white text-left"
                                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                > 
                                    <span className="font-inter">
                                        {dish.categoryid
                                            ? dish.categoryid === 0
                                                ? "- Geen categorie -"
                                                : categories.find(c => c.id === dish.categoryid)?.name
                                            : "- Geen categorie -"}
                                    </span>
                                    <ChevronDown className="h-4 w-4" />
                                </button>
                                {isDropdownOpen && (
                                    <div className="absolute z-10 w-full mt-1 bg-white border rounded shadow-lg max-h-[220px] overflow-auto">
                                        <div
                                            key={0}
                                            className="p-2 hover:bg-gray-100 cursor-pointer font-inter"
                                            onClick={() => handleCategoryChange(0)}
                                        >
                                            - Geen categorie -
                                        </div>
                                        {[...categories] // Maak een kopie van de array om de originele array niet te muteren
                                            .sort((a, b) => a.name.localeCompare(b.name)) // Sorteer op naam
                                            .map((category) => (
                                            <div
                                                key={category.id}
                                                className="p-2 hover:bg-gray-100 cursor-pointer font-inter"
                                                onClick={() => handleCategoryChange(category.id)}
                                            >
                                                {category.name}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            <div className="flex items-center space-x-2 py-4">
                                <StyledSwitch
                                    title="Publiceren"
                                    checked={dish.ispublished}
                                    onCheckedChange={handleSwitchChange}
                                    id="publish-mode"
                                />
                            </div>
                        </div>

                        <div className="flex justify-end">
                            {(dish && dishId > 0) ? (
                                <Button
                                    variant="destructive"
                                    onClick={() => setIsDeleteModalOpen(true)}
                                    className="flex gap-2 w-60 bg-red-700 text-white hover:opacity-80 mr-2"
                                >
                                    Verwijderen
                                </Button>
                            ) : (
                                <Button
                                        variant="destructive"
                                        disabled="true"
                                        className="flex gap-2 w-60 bg-gray-700 text-white hover:opacity-80 mr-2"
                                >
                                    Verwijderen
                                </Button>
                            )}
                            <Button
                                onClick={handleSave}
                                disabled={isSaving}
                                className="bg-ps-blue-dark hover:bg-ps-blue-darker text-white w-60"
                            >
                                {isSaving ? 'Opslaan...' : 'Opslaan'}
                            </Button>
                        </div>
                        <ConfirmationModal
                            isOpen={isDeleteModalOpen}
                            onClose={() => setIsDeleteModalOpen(false)}
                            onConfirm={handleDeleteDish}
                            title="Verwijder gerecht"
                            message="Weet je zeker dat je dit gerecht wilt verwijderen?"
                        />


                        {dishId !== 0 && (
                            <div>
                                <label className="block text-sm font-inter text-ps-blue-dark mb-4">
                                    Producten
                                </label>

                                    <div className="space-y-2">
                                        {dish.products && dish.products.map((product) => (
                                            <div
                                                key={product.id}
                                                className="flex items-center justify-between w-full p-3 hover:pl-6 cursor-default border-b-[1px]"
                                            >
                                                <span className="font-inter">{product.name}</span>
                                                <div className="flex items-center gap-6"> 
                                                    <Trash2 className="text-ps-pink cursor-pointer" size={20}
                                                        onClick={() => handleRemoveProduct(product.id)} />
                                                </div>
                                            </div>
                                        ))}
                                        <div className="flex justify-end mt-4">
                                        <Button
                                            onClick={handleAddProduct}
                                                className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 bg-ps-green hover:bg-ps-green/90 text-white px-4 py-2 shadow-lg rounded-full">
                                            <Plus className="h-6 w-6" />
                                                <span>Product toevoegen</span>
                                            </Button>
                                            <ProductModal
                                                isOpen={isProductModalOpen}
                                                onClose={() => setIsProductModalOpen(false)}
                                                onSave={handleSaveProduct} 
                                            />
                                        </div>
                                    </div>
                            </div>
                        )}
                    </div>

                    <div className="md:col-span-1">

                        {dishId !== 0 && (
                            <>
                        <div>
                            <label className="block text-sm font-inter text-ps-blue-dark mb-2">
                                Allergenen 
                            </label>
                            {dish.allergens && dish.allergens.length > 0 && (
                                <div className="flex flex-col pb-2">

                                    {dish.allergens
                                        .filter(allergen => allergenIcons[allergen.id])
                                                .map((allergen) => ( 
                                            <div
                                                key={allergen.id}
                                                className="flex items-center gap-2 p-1"
                                            >
                                                <img
                                                    src={allergenIcons[allergen.id]}
                                                    alt={allergen.name}
                                                    className="w-6 h-6"
                                                />
                                                <span className="font-inter text-sm">{allergen.name}</span>
                                                        </div> 
                                        ))}
                                </div>
                            )}
                        </div>

                        <div className="mt-6 mb-2">
                            <label className="block text-sm font-inter text-ps-blue-dark mb-2">
                                Dieet wensen
                            </label>
                            {dish.dietaryneeds && dish.dietaryneeds.length > 0 && (
                                <div className="flex flex-col pb-2">
                                    {dish.dietaryneeds.map((dietary) => (
                                        <div
                                            key={dietary.id}
                                            className="flex items-center gap-2 p-1"
                                        >
                                            <img
                                                src={dietaryIcons[dietary.id] || empty}
                                                alt={dietary.name}
                                                className="w-6 h-6"
                                            />
                                            <span className="font-inter text-sm">{dietary.name}</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                                <div className="flex justify-end mt-4">
                            <Button
                                            onClick={() => setIsModalOpen(true)} 
                                            className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 bg-ps-green hover:bg-ps-green/90 text-white px-4 py-2 shadow-lg rounded-full"
                            >
                                            <Plus className="h-6 w-6" />
                                <span>Dieet wens toevoegen</span>
                                        </Button>
                                        <DietaryNeedsModal
                                            isOpen={isModalOpen}
                                            onClose={() => setIsModalOpen(false)}
                                            onSave={handleSaveDietaryNeeds}
                                            selectedDietaryNeeds={dish.dietaryneeds}
                                        />
                                </div>
                                </div>
                            </>
                        )}


                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Dish;